import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/kakobuy-spreadsheet-poradnik/page";
import SafetyArticle from "@/pages/article/kakobuy-bezpieczenstwo/page";
import ShippingArticle from "@/pages/article/kakobuy-wysylka-polska/page";
import ComparisonArticle from "@/pages/article/kakobuy-porownanie-agentow/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-poradnik",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/kakobuy-bezpieczenstwo",
    element: <SafetyArticle />,
  },
  {
    path: "/artykul/kakobuy-wysylka-polska",
    element: <ShippingArticle />,
  },
  {
    path: "/artykul/kakobuy-porownanie-agentow",
    element: <ComparisonArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;